export default __webpack_public_path__ + "static/media/pngwing.com.210ec988.webp";